import styled from 'styled-components'

export const Title = styled.h2`
  text-transform: capitalize;
  line-height: 1;
  font-weight: 400;
  text-align: center;
  margin: ${props => props.hasDescription ? '4.8rem auto 0' : '4.8rem auto'};

  &:after {
    content: '';
    display: block;
    height: 1px;
    background-color: ${props => props.theme.colors.cobalt};
    max-width: ${props => props.theme.sizes.maxWidthTitle};
    margin: 2rem auto 3rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin: ${props => props.hasDescription ? '8rem auto 0' : '8rem auto'};
  }
`

export const Description = styled.div`
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  text-align: center;
  margin: 1rem auto 4.8rem;

  p {
    margin: 0 auto 3rem;
  }

  .gatsby-resp-image-wrapper {
    margin-top: 8rem;
    margin-bottom: 3.6rem;
  }

  h3 {
    margin-top: 8rem;
    margin-bottom: 1.6rem;

    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 27rem;
      margin: 1.2rem auto 0;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 8rem;
  }
`
